import { render, staticRenderFns } from "./SetupKiosk.vue?vue&type=template&id=6bff6c4b&scoped=true"
import script from "./SetupKiosk.vue?vue&type=script&lang=js"
export * from "./SetupKiosk.vue?vue&type=script&lang=js"
import style0 from "./SetupKiosk.vue?vue&type=style&index=0&id=6bff6c4b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bff6c4b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\BabaBello\\bababelloapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bff6c4b')) {
      api.createRecord('6bff6c4b', component.options)
    } else {
      api.reload('6bff6c4b', component.options)
    }
    module.hot.accept("./SetupKiosk.vue?vue&type=template&id=6bff6c4b&scoped=true", function () {
      api.rerender('6bff6c4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/kiosk/SetupKiosk.vue"
export default component.exports